import { Col, PageHeader, Row } from "antd";
import * as React from "react";
import { useRecoilValue } from "recoil";
import { Table } from "src/components";
import DeskPanel from "src/components/DeskPanel/DesktPanel";
import { useWebsiteSystem } from "src/hooks/useWebsiteSystem";
import { authInfoState } from "src/recoils";
import { Scope } from "src/types";
import { getColumns } from "./config/columns";

export interface IWebsiteSystemProps {}

const Header = () => (
  <Row gutter={[8, 0]} style={{ marginBottom: 10 }}>
    <Col flex="1 1 200px">
      <PageHeader title="ระบบเว็บไซต์" style={{ fontSize: 20, padding: 0 }} />
    </Col>
  </Row>
);

const WebsiteSystem: React.FunctionComponent<IWebsiteSystemProps> = () => {
  const { scope } = useRecoilValue(authInfoState);
  // View access is gated on BannerPage at the route level (src/config/routes.ts);
  // BannerPageEdit only decides whether switches/แก้ไข are interactive here.
  const canEdit = scope[Scope.BannerPageEdit]?.enable || false;
  const { data, isLoading, isError, error } = useWebsiteSystem();

  return (
    <div id="WebsiteSystem">
      <DeskPanel
        body={
          <>
            <Header />
            {isError ? (
              <div style={{ padding: 24, textAlign: "center", color: "#ff4d4f" }}>
                {error instanceof Error ? error.message : "โหลดข้อมูลไม่สำเร็จ"}
              </div>
            ) : (
              <Table
                rowKey="code"
                columns={getColumns({ canEdit })}
                dataSource={data}
                loading={{ spinning: isLoading }}
                // NOTE: src/components/Table destructures `pagination` then spreads
                // it into an object of defaults ({ ...pagination }) - passing
                // `false` is a no-op there (spreading false into an object literal
                // does nothing), so it silently falls back to the default pager
                // instead of being disabled. hideOnSinglePage correctly hides the
                // pager for this fixed 4-row table without relying on that gap.
                pagination={{ hideOnSinglePage: true }}
              />
            )}
          </>
        }
      />
    </div>
  );
};

export default WebsiteSystem;
